import { loadable } from 'nordic/lazy';
import preloadIframe from '.';

const PreloadIframe = loadable(() => import('../../../../components/preload-iframe'));

const configuredPreloadIframe = preloadIframe(PreloadIframe);
export default configuredPreloadIframe;
